import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import FieldOptions, { selectField } from './field-options';
import FieldInput from './field-input';
import { AddDynamicFieldRepository } from '../../../../services/api/dynamic-fields-api';
import FluentUiIcon from '../../../../assets/fluent-ui-icon';
import { errorNotification, successNotification } from "../../../../redux/notifications";
import { useDispatch } from 'react-redux';
import PropTypes from "prop-types";
import { FIELD_TYPES } from '../../../../components/DynamicField/Tasks/utils/utils';

const CreateField = ({ show, onHide, GetFieldRepository }) => {

    const dispatch = useDispatch();
    const [fieldType, setFieldType] = useState();
    const [fieldValues, setFieldValues] = useState({ Label: '', APIName: '', Description: '', FieldType: '', Visible: true, Deleted: false, LookupValues: ["", ""] });

    useEffect(() => {
    if (fieldType == null) 
        return;

    setFieldValues(prev => {
        if (fieldType.value === FIELD_TYPES.table) {
            return {
                ...prev,
                FieldType: fieldType.value,
                Table: { Columns: [] },
            };
        }

        if (fieldType.value === FIELD_TYPES.url) {
            const newLookup = [...(prev.LookupValues || [])];

            if (!newLookup[0]) {
                newLookup[0] = "https://";
            }

            return {
                ...prev,
                FieldType: fieldType.value,
                LookupValues: newLookup,
            };
        }

        if (prev.FieldType === FIELD_TYPES.url) {
            return {
                ...prev,
                FieldType: fieldType.value,
                LookupValues: ["", ""],
            };
        }

        return {
            ...prev,
            FieldType: fieldType.value,
        };
    });
    }, [fieldType]);

    const onCreateField = () => {

        AddDynamicFieldRepository(fieldValues)
            .then((res) => {
                if (res.status === 200) {
                    GetFieldRepository();
                    onHide();
                    dispatch(successNotification({
                        header: "Field Created",
                        message: `The field "${fieldValues.Label}" has been created successfully`
                    }));
                }
                else {
                    onHide();
                    dispatch(errorNotification({
                        header: "Field Creation failed",
                        message: "The field could not be created" + res
                    }));
                }
            })
            .catch((err) => {
                onHide();
                dispatch(errorNotification({
                    header: "Field Creation failed",
                    message: "The field could not be created" + err?.toString()
                }));
                console.log("Error [AddDynamicFieldRepository] => ", err);
            });
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            contentClassName="dashboard-modal-styles fieldRepoModal"
            dialogClassName="dashboard-modal"
            scrollable={true}
        >
            <Modal.Header
                className="dashboard-modal-header"
                closeButton
            >
                <Modal.Title className="modal-title">
                    <span>Create a new Field</span>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="">
                {
                    fieldType
                        ?
                        <div className='field-input'>
                            <Button variant="link" onClick={() => { setFieldType(); setFieldValues({ Label: '', APIName: '', Description: '', FieldType: '', Visible: true, Deleted: false, LookupValues: ["", ""] }) }} className='back-button'>
                                <FluentUiIcon name={'ArrowLeftRegular'} color={'#0F6CBD'} size={20} />
                                <span>Back</span>
                            </Button>
                            <div className='field-create-edit-btn'>
                                {selectField({ fields: [fieldType] })}
                                <div className="action-btns">
                                    <Button className="btn-outlined"
                                        onClick={onHide}
                                        variant="primary">
                                        Cancel
                                    </Button>
                                    <Button
                                        onClick={onCreateField}
                                        disabled={fieldValues.Label.length < 1}
                                        className=""
                                        variant="primary">
                                        Save
                                    </Button>
                                </div>
                            </div>
                            <FieldInput
                                fieldValues={fieldValues}
                                setFieldValues={setFieldValues}
                                setFieldType={setFieldType}
                            />
                        </div>
                        :
                        <>
                            <h3 className="select-field">Select a field type...</h3>
                            <FieldOptions setFieldType={setFieldType} />
                        </>
                }
            </Modal.Body>
        </Modal>
    );
}

CreateField.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    GetFieldRepository: PropTypes.func.isRequired,
};

export default CreateField;